import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
export class ProfileService extends BaseProvider {
    constructor(globals, http, ls) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.showManagement = false;
        this.itemToEdit = {};
        this.goToTransaction = false;
        this.selectedProfileIdSubject = new BehaviorSubject(null);
        this.selectedProfileId$ = this.selectedProfileIdSubject.asObservable();
        this.selectedProfileId = null;
        this.openedByAdmin = false;
        // Sistema de caché para perfiles
        this.profilesCache = null;
        this.cacheTimestamp = null;
        this.CACHE_TTL = 5 * 60 * 1000; // 5 minutos en milisegundos
        this.baseUrl = 'profile';
        // Initialize with current value
        this.selectedProfileId = this.getSelectedProfileId();
        this.selectedProfileIdSubject.next(this.selectedProfileId);
    }
    getSelectedProfileId() {
        if (this.selectedProfileId) {
            return this.selectedProfileId;
        }
        const profileData = localStorage.getItem('selectedProfile');
        if (profileData && profileData !== 'null') {
            this.selectedProfileId = JSON.parse(profileData).Id;
            this.selectedProfileIdSubject.next(this.selectedProfileId);
        }
        return this.selectedProfileId;
    }
    getSelectedProfile() {
        const profileData = localStorage.getItem('selectedProfile');
        if (profileData) {
            return JSON.parse(profileData);
        }
        return null;
    }
    setSelectedProfileId(id) {
        this.selectedProfileId = id;
        this.selectedProfileIdSubject.next(id);
    }
    getByCompanyId(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            const loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.itemToEdit = data.Data;
                resolve(this.itemToEdit);
            }, err => { reject(err); });
        });
    }
    search(params, forceRefresh = false) {
        return new Promise((resolve, reject) => {
            const hasSearchTerm = params.term && params.term.trim() !== '' && params.term !== 'null';
            if (!forceRefresh && !hasSearchTerm && this.profilesCache && this.cacheTimestamp) {
                const now = Date.now();
                const cacheAge = now - this.cacheTimestamp;
                if (cacheAge < this.CACHE_TTL) {
                    this.list = this.profilesCache;
                    resolve(this.profilesCache);
                    return;
                }
            }
            // Construir URL con endpoint v2
            this.url = this.globals.dataUrl + this.baseUrl + '/v2/user';
            // Construir query params - convertir term a string vacío si es 'null'
            let termValue = params.term || '';
            if (termValue === 'null') {
                termValue = '';
            }
            const queryParams = new HttpParams()
                .set('term', termValue)
                .set('page', params.pageNumber.toString())
                .set('size', params.pageSize.toString());
            this.http
                .get(this.url, { params: queryParams })
                .subscribe((data) => {
                this.list = data.Data;
                // Solo cachear si no hay término de búsqueda
                if (!hasSearchTerm) {
                    this.profilesCache = data.Data;
                    this.cacheTimestamp = Date.now();
                }
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    // Limpia la caché de perfiles
    clearProfilesCache() {
        this.profilesCache = null;
        this.cacheTimestamp = null;
    }
    getById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/' + id;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getByUser(params) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/v2/user`;
            const termValue = params.term && params.term.trim() !== '' ? params.term.trim() : 'null';
            const queryParams = new HttpParams()
                .set('term', termValue)
                .set('page', params.pageNumber.toString())
                .set('size', params.pageSize.toString());
            this.http
                .get(this.url, { params: queryParams })
                .subscribe((data) => {
                this.list = data.Data || [];
                resolve(data.Data || []);
            }, err => { reject(err); });
        });
    }
    create(params) {
        return new Promise((resolve, reject) => {
            const url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    update(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + params.Id;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    createV2(params) {
        return new Promise((resolve, reject) => {
            const url = this.globals.dataUrl + this.baseUrl + '/postV2';
            this.http
                .post(url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    updateV2(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/updateV2/' + params.Id;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    updateSignature(profileId, signature) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/signature/' + profileId;
            this.http
                .put(this.url, { signature })
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getSignature(profileId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/signature/' + profileId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    uploadImage(params, profileId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/file/' + profileId;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => {
                reject(err);
            });
        });
    }
    deleteSignature(profileId) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/signature/${profileId}`;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    adminGetProfiles(term, isIndividual, isStampsModule, profileType, pageNumber, pageSize) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/term/${term}/isIndividual/${isIndividual}/isStampsModule/${isStampsModule}/profileType/${profileType}/page/${pageNumber}/size/${pageSize}`;
            this.http.get(url).subscribe((data) => { resolve(data); }),
                (err) => { reject(err); };
        });
    }
    setProfileAsExempt(data) {
        return new Promise((resolve, reject) => {
            let url = `${this.globals.dataUrl}${this.baseUrl}/updateParams`;
            this.http.put(url, data).subscribe((data) => { resolve(data); }),
                (err) => { reject(err); };
        });
    }
    getRecommendationBySSN(ssn) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/recommendation/companion/" + ssn;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
}
ProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileService_Factory() { return new ProfileService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService)); }, token: ProfileService, providedIn: "root" });
